module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Beautiful Birdie Biscuits")])]), _vm._v(" "), _c('h3', {
    staticClass: "CAU"
  }, [_c('strong', [_vm._v("BY RUTH CLEMENS")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-1.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_c('strong', [_c('em', [_vm._v("You Will Need:")])])]), _vm._v(" "), _c('p', {
    staticClass: "ML"
  }, [_vm._v("Circular biscuits (7.5cm/3in diameter)")]), _vm._v(" "), _c('p', {
    staticClass: "ML"
  }, [_vm._v("White, blue, purple and pink sugarpaste")]), _vm._v(" "), _c('p', {
    staticClass: "ML"
  }, [_vm._v("Pink, purple, golden yellow and black royal icing")]), _vm._v(" "), _c('p', {
    staticClass: "ML"
  }, [_vm._v("Fluted cookie cutter and small round cutter")]), _vm._v(" "), _c('p', {
    staticClass: "ML"
  }, [_vm._v("Petal cutters, Large, small and extra small rose petal")]), _vm._v(" "), _c('div', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Roll out the white sugarpaste to 3mm ("), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _vm._v("in) thick; cut out a fluted circle. Secure to the top of a biscuit using a little water.")]), _vm._v(" "), _c('div', {
    staticClass: "SbS2"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Roll out the blue sugarpaste to 2mm ("), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("32")])]), _vm._v("in) thick; cut out the bird’s body using the large petal cutter and use the small round cutter to cut out the bird’s head. Roll out the purple sugarpaste to 2mm ("), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("32")])]), _vm._v("in) thick and cut out three tail feathers with the extra small petal cutter. Set aside.")]), _vm._v(" "), _c('div', {
    staticClass: "SbS2"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Roll out the pink sugarpaste, to 2mm ("), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("32")])]), _vm._v("in) thick and cut out a small petal for the bird’s wing.Pinch the thin end of the petal and curve the shape slightly to create the curve of the wing. Use a knife to mark three lines along the wing.")]), _vm._v(" "), _c('div', {
    staticClass: "SbS2"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Start to build the bird onto the biscuit using the pieces you have cut out. Start with the tail feathers securing them in position with a dab of water. Add the body, the head and finally the wing.")]), _vm._v(" "), _c('div', {
    staticClass: "SbS2"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Using the black royal icing, pipe a dot for the bird’s eye and two legs. Add a beak with golden yellow royal icing.")]), _vm._v(" "), _c('div', {
    staticClass: "SbS2"
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Finally pipe three pink bulbs between the bird’s feet and tail feathers and three purple bulbs to the right of the bird’s head.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431e0c5f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c02.vue
// module id = 66
// module chunks = 0